<template>
  <BaseImage
    alt="Crafty Copilot Avatar"
    :background-color="backgroundColor"
    border-radius="round"
    :class="`copilot-image--${mode}`"
    :src="aviSrc"
    :style="{ width, height }"
  />
</template>

<script lang="ts">
import BaseImage from './BaseImage.vue'
import aviDefault from '../assets/images/avi/avi-default.png'
import { defineComponent } from 'vue'
import { type PropType } from 'vue'

type CraftyCopilotImageMode = 'portrait' | 'full'
type Width = CSSStyleDeclaration['width']
type Height = CSSStyleDeclaration['height']

export default defineComponent({
  name: 'CraftyCopilotImage',
  components: {
    BaseImage,
  },
  props: {
    mode: {
      type: String as PropType<CraftyCopilotImageMode>,
      default: 'portrait',
    },
    width: {
      type: String as PropType<Width>,
      default: 'auto',
    },
    height: {
      type: String as PropType<Height>,
      default: 'auto',
    },  
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
  },
  data() {
    return {
      aviSrc: aviDefault,
    }
  },
})
</script>

<style lang="scss" scoped>
.copilot-image--portrait :deep(.crafty-image__img) {
  transform: scale(1.6);
  transform-origin: 20px top;
}
</style>
